<template>
  <div
    class="infinite-loading"
    :style="{ height: maxHeight }"
  >
    <div class="infinite-loading__list-group">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      required: true
    },
    itemsPerScroll: {
      type: Number,
      default: 20
    },
    maxHeight: {
      type: Number
    }
  },
  data () {
    return {
      actualGroupList: 0,
      listGroups: []
    }
  },
  computed: {
    totalGroups () {
      return Math.ceil(this.list.length / this.itemsPerScroll)
    }
  },
  watch: {
    list: {
      immediate: true,
      handler () {
        this.formatListInGroups()
      }
    }
  },
  mounted () {
    this.formatListInGroups()
  },
  created () {
    window.addEventListener('scroll', this.getScrollPosition)
  },
  destroyed () {
    window.removeEventListener('scroll', this.getScrollPosition)
  },
  methods: {
    formatListInGroups () {
      this.listGroups.length = 0
      this.list.map((_, index) => {
        let start = index * this.itemsPerScroll
        let end = start + this.itemsPerScroll

        if (index < this.totalGroups) { this.listGroups.push(this.list.slice(start, end)) }
      })
      this.$emit('update-list', this.listGroups[this.actualGroupList])
    },
    getScrollPosition () {
      const { clientHeight, scrollHeight, scrollTop } =
        document.documentElement
      const isAlmostInTheEnd = scrollTop + clientHeight >= scrollHeight - 20
      const indexOfTotalGroups = this.totalGroups - 1

      if (isAlmostInTheEnd && this.actualGroupList < indexOfTotalGroups) { this.loadMore() }
    },
    loadMore () {
      this.actualGroupList++
      this.$emit('load-more', this.listGroups[this.actualGroupList])
    }
  }
}
</script>

<style lang="scss">
.infinite-loading {
  overflow-y: auto;
}
</style>
